/** Message shown when a member cannot be removed because they are the project's resource owner */
export const REMOVE_RESOURCE_OWNER_MESSAGE = "You cannot remove this member because they are the resource owner of the project.";